const AuthRoutes = {
  login: 'login',
  logout: 'logout',
  sendWhatsAppOtp: 'send_whatsapp_otp',
  sendEmailOtp: 'send_email_otp',
  sendVerificationCode: 'sendVerificationCode',
  verifyOtp2: 'verify_otp',
  verifyOtp: 'verifyVerificationCode',
  changePassword: 'changePassword',
  changeEmail: 'changeEmail',
  changeContact: 'changeContact',
  forgotPassword: 'forgotPassword',
  resetPassword: 'resetPassword',
  getCountries: 'countries',
  getCities: 'citiesByCountryId/',
};

export default AuthRoutes